var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonRegular',{staticClass:"rounded-12 bg-leaf text-white enabled:active:bg-[#23CE6B]",attrs:{"size":_vm.size,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }